<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title"> 시차근무신청 </v-col>
    </v-row>

    <div class="overflow-y-auto">
      <v-list>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in list" :key="i" class="gntType-item">
            <v-list-item-content @click="selectMenu(item)">
              <v-list-item-title>
                <span class="time">{{ item.codeNm }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import {
  getWorkScheduleTimeCd,
  getWorkScheduleResonTermCheck,
} from '@/api/workStatus';
import routerNames from '@/const/routerConstants';
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';

export default {
  data: () => ({
    list: [],
  }),

  computed: {
    ...mapGetters(['GET_APPL_CD']),
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_BTN
      }px;`;
    },
  },

  methods: {
    /* 신청서 선택 */
    async selectMenu(item) {
      this.$store.commit('SET_WORK_TYPE_CD', item.code);
      this.$store.commit('SET_WORK_TYPE_NM', item.codeNm);
      this.$store.commit('SET_NOTE2', item.note2);

      if (item.code === '20' || item.code === '10') {
        const params = {
          reasonCd: item.code,
          searchYmd: dayjs().format('YYYYMMDD'),
        };
        const response = await getWorkScheduleResonTermCheck(params);

        if (response.data.data.famCnt === 0) {
          if (item.code === '20') {
            alert(
              '등록된 자녀 사항이 없습니다. 인사기본에서 등록 후 신청해주시기 바랍니다.',
            );
          } else {
            alert('임산부보호 신청된 내역이 없습니다.신청해주시기 바랍니다.');
          }

          return;
        }
      }

      if (item.code === '30') {
        const params = {
          reasonCd: item.code,
          searchYmd: dayjs().format('YYYYMMDD'),
        };
        const response = await getWorkScheduleResonTermCheck(params);

        if (response.data.data.famCnt === 0) {
          alert(
            '등록된 자녀 사항이 없습니다. 인사기본에서 등록 후 신청해주시기 바랍니다.',
          );

          return;
        }
      }

      this.$router.push(routerNames.WorkScheduleTimeView);
    },
  },

  async mounted() {
    let params = {
      grcodeCd: 'T10100',
    };

    let response = await getWorkScheduleTimeCd(params);
    this.list = response.data.data;
  },
};
</script>

<style></style>
